import React from 'react'
import type { TableRowProps } from '@ui/stickybid'
import { TableRow } from '@ui/stickybid'

export interface ItemTableRowProps extends TableRowProps {}

export default function ItemTableRow(props: ItemTableRowProps) {
  return <TableRow {...props} component="tr" />
}
